<script setup lang="ts">
import type { MenuItem } from '~/types'

interface Props {
  menuItem: MenuItem.Model
}

const props = defineProps<Props>()
const { menuItem } = toRefs(props)
const { handleClick, isOpen, name } = useMenuItem(menuItem)
</script>

<template>
  <button
    tabindex="0"
    aria-haspopup="true"
    :aria-expanded="isOpen"
    class="text-menu-item"
    @click="handleClick"
  >
    {{ name }}
  </button>
</template>
